// lib/LocalizedQuotationMarks/lib/consumes.ts
var e = ({ input: e }) => {
	let { data: t, type: n } = e;
	return n !== "text/plain" || t !== "'" && t !== "\"" && t !== "-" ? [!1] : [!0, "text/plain"];
};
export { e as consumes };
